module.exports = __webpack_public_path__ + "linkedin-share-5f10143933f451d2ef06.svg";